import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'

import * as styles from './SocialIcons.module.scss'

import FacebookIcon from '@images/social_facebook.svg'
import LinkedinIcon from '@images/social_linkedin.svg'
import TwitterIcon from '@images/social_twitter.svg'

interface Props {
	className?: string
}

const SocialIcons = (props: Props) => {
	const data = useStaticQuery<Queries.SocialLinksQuery>(graphql`
		query SocialLinks {
			wp {
				acfOptionsSocialLinks {
					socialMediaOptions {
						facebook
						twitter
						linkedin
					}
				}
			}
		}
	`)

	const socialLinks = data.wp?.acfOptionsSocialLinks?.socialMediaOptions
	const classNames = [styles.socialIcons]

	if (props.className) {
		classNames.push(props.className)
	}

	return (
		<ul className={classNames.join(' ')}>
			{socialLinks?.facebook && (
				<li>
					<a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
						<FacebookIcon />
					</a>
				</li>
			)}
			{socialLinks?.twitter && (
				<li>
					<a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
						<TwitterIcon />
					</a>
				</li>
			)}
			{socialLinks?.linkedin && (
				<li>
					<a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer">
						<LinkedinIcon />
					</a>
				</li>
			)}
		</ul>
	)
}

export default SocialIcons
